module.exports = __webpack_public_path__ + "static/img/4.0958230.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/4.png
// module id = Umjs
// module chunks = 0